var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    rx: 6,
    fill: "#E5E5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2308 5.23077V4H14.7692V5.23077V10.7692H9.23077H8V13.2308H9.23077H14.7692V18.7692V20H17.2308V18.7692V13.2308H22.7692H24V10.7692H22.7692H17.2308V5.23077Z",
    fill: "#1A2F77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPlusIcon);
export default __webpack_public_path__ + "static/media/sidebar-plus-icon.7f963951abf5df97bf2f09cd100edc1c.svg";
export { ForwardRef as ReactComponent };